export function getActiveRoute(pathname: string): string {
  // Remove leading slash → "/courses/123" → "courses/123"
  const path = pathname.startsWith("/") ? pathname.slice(1) : pathname;

  // Split → ["courses", "123"]
  const parts = path.split("/");

  // Return only the first segment
  return parts[0] || "dashboard";
}
